import { all, spawn, call } from 'redux-saga/effects';

// account
import { watchLoginRequest, watchLogoutRequest } from '../features/account/login/login.saga';
import { watchForgotPasswordRequest } from '../features/account/forgotPassword/forgotPassword.saga';
import { watchResetPasswordRequest } from '../features/account/resetPassword/resetPassword.saga';
import { watchChangePasswordRequest } from '../features/account/changePassword/changePassword.saga';

import {watchGetUsersRequest, watchCreateUserRequest, watchUpdateUserRequest, watchGetUserRequest} from '../features/users/users.saga'
import {watchGetExhibitsRequest, watchGetExhibitRequest, watchCreateExhibitRequest, watchUpdateExhibitRequest} from '../features/exhibits/exhibits.saga'
import {watchGetGroupVisitsRequest, watchGetGroupVisitRequest, watchCreateGroupVisitRequest, watchUpdateGroupVisitRequest, watchGetGroupVisitPasswordResetRequiredRequest, watchGroupResetPasswordRequest, watchGroupChangePasswordRequest, watchGroupForgotPasswordRequest} from '../features/groupVisits/groupVisits.saga';
import {watchGetResourceRequest, watchGetResourcesRequest, watchCreateResourceRequest, watchUpdateResourceRequest} from '../features/visitorInformation/components/cards/facilityResources/resources.saga';
import {watchGetDayRequest, watchGetDaysRequest, watchCreateDayRequest, watchUpdateDayRequest} from '../features/visitorInformation/components/cards/hours/hours.saga';
import {watchGetExtrasRequest, watchGetInfoRequest, watchCreateExtraRequest, watchUpdateExtraRequest} from '../features/visitorInformation/visitorInformation.saga';
import {watchCreateNotificationRequest, watchGetNotificationRequest} from '../features/notifications/notifications.saga';
import {watchLoginGroupVisitRequest} from '../features/groupVisits/components/summary/login/login.saga'
import { watchRolesGetRequest } from '../common/sagas/roles.saga';

export default function* rootSaga() {
  const sagas: any[] = [
    /* List sagas here*/
    watchLoginRequest, watchLogoutRequest,
    watchForgotPasswordRequest, 
    watchResetPasswordRequest,
    watchChangePasswordRequest,
    watchGetUsersRequest, watchCreateUserRequest, watchUpdateUserRequest, watchGetUserRequest,
    watchGetExhibitsRequest, watchGetExhibitRequest, watchCreateExhibitRequest, watchUpdateExhibitRequest,
    watchGetGroupVisitsRequest, watchGetGroupVisitRequest, watchCreateGroupVisitRequest, watchUpdateGroupVisitRequest, watchGetGroupVisitPasswordResetRequiredRequest, watchGroupResetPasswordRequest, watchGroupChangePasswordRequest, watchGroupResetPasswordRequest, watchGroupForgotPasswordRequest,
    watchGetResourceRequest, watchGetResourcesRequest, watchCreateResourceRequest, watchUpdateResourceRequest,
    watchGetDayRequest, watchGetDaysRequest, watchCreateDayRequest, watchUpdateDayRequest,
    watchGetExtrasRequest, watchGetInfoRequest, watchCreateExtraRequest, watchUpdateExtraRequest,
    watchCreateNotificationRequest, watchGetNotificationRequest,
    watchLoginGroupVisitRequest,
    watchRolesGetRequest
  ];

  yield all(sagas.map(saga =>
    spawn(function* () {
      while (true) {
        try {
          yield call(saga)
          break
        } catch (e) {
          console.log(e)
        }
      }
    }))
  );
}